import { JobType } from "app/pages/module/types/jobtype/Jobtype";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getJobType = async (queryParams?:any) => {
  return await get<ApiResponse<JobType[]>>(queryParams ? `/individual/job/category?${queryParams}` :  "/individual/job/category").then((res)=>{
    return res
  })
};
